
import { SectionCarouselProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import Carousel from '@/components/molecules/Carousel';
import TestimonialCard from '@/components/molecules/TestimonialCard';
import Text from '@/components/molecules/Text';
import Title_v2 from '@/components/molecules/Title/index';
import UserCard from '@/components/molecules/UserCard';
import { TestimonialCardProps, UserCardProps } from '@/queries/components/molecules';
import { renderUnderline } from '@/utilities/functions';

const SectionCarousel = ({ carouselData }: { carouselData: SectionCarouselProps }) => {

	return (
		<>
			<Title_v2
				align={carouselData.title.alignedAt}
				underlineColor={carouselData.title.underlineColor}
			>
				{renderUnderline(carouselData.title.titlePieces)}
			</Title_v2>
			{carouselData.description && (
				<Text>
					{carouselData.description}
				</Text>
			)}
			<Carousel>
				{carouselData.carousel.data.attributes.content.map(
					(content: any, index: number) => {
						switch (content.__typename) {
							case 'ComponentCardTestimonialCard': {
								return (
									<TestimonialCard
										{...content as TestimonialCardProps}
										key={index}
										userPicture={{
											name: content.userPicture.data.attributes.name,
											url: content.userPicture.data.attributes.url,
										}}
									/>
								);
							}
							case 'ComponentCardUserCard': {
								return (
									<UserCard
										{...content as UserCardProps}
										key={index}
										userImage={content.userPicture.data.attributes.url}
									/>
								);
							}
							default: console.log(content.__typename);
						}
					},
				)}
			</Carousel>
			{
				carouselData.buttons.map(
					(button, index) => (
						<Button_v2
							gtm_id={button.trackerId}
							href={button.url}
							key={index}
							openOnNewTab={button.newTab}
							text={button.text}
							version={button.variant}
						/>
					),
				)
			}
		</>
	);
};

export default SectionCarousel;
